module.exports = "<ngx-paypal [config]=\"payPalConfig\"></ngx-paypal>"